module.exports = __webpack_public_path__ + "img/carshina21_07.87e4eec0.jpg";